import {useId} from "react";
import "./NexusMotion.css";

/** Small, decorative status artwork based on the MB Nexus motion previews. */
export default function NexusMotion({variant="eye",active=true,size="normal"}){
  const gradient=useId().replace(/:/g,"");
  return <span className={`nexus-motion nexus-motion--${variant} nexus-motion--${size} ${active?"is-active":"is-idle"}`} aria-hidden="true">
    <span className="nexus-motion__orbit"/>
    {variant==="eye"?<svg viewBox="0 0 180 120" fill="none">
      <defs><radialGradient id={gradient}><stop stopColor="#032134"/><stop offset=".55" stopColor="#16b9e9"/><stop offset="1" stopColor="#075079"/></radialGradient></defs>
      <path className="nexus-motion__trace" d="M5 60h19m132 0h19M90 4v17m0 78v17"/>
      <ellipse className="nexus-motion__ring" cx="90" cy="60" rx="55" ry="55"/>
      <path className="nexus-motion__eye" d="M12 60Q90-21 168 60Q90 141 12 60Z"/>
      <circle className="nexus-motion__iris" cx="90" cy="60" r="31" fill={`url(#${gradient})`}/>
      <circle className="nexus-motion__pupil" cx="90" cy="60" r="13"/>
      <path className="nexus-motion__scan" d="M40 60h100"/>
    </svg>:variant==="brain"?<svg viewBox="0 0 180 120" fill="none">
      <path className="nexus-motion__brain" d="M88 22C74 10 53 15 49 32c-18-2-26 15-20 28-13 13-5 30 8 31 0 16 19 22 29 14 12 12 24 1 24-10 0 11 12 22 24 10 10 8 29 2 29-14 13-1 21-18 8-31 6-13-2-30-20-28-4-17-25-22-39-10Z"/>
      <path className="nexus-motion__fold" d="M90 23v72M49 32q28 9 19 28t-31 31m29 14q-8-29 24-45m41-28q-28 9-19 28t31 31m-29 14q8-29-24-45"/>
      <g className="nexus-motion__nodes"><circle cx="54" cy="47" r="3"/><circle cx="68" cy="76" r="3"/><circle cx="90" cy="60" r="4"/><circle cx="112" cy="76" r="3"/><circle cx="126" cy="47" r="3"/></g>
    </svg>:<svg viewBox="0 0 180 120" fill="none">
      <circle className="nexus-motion__ring" cx="90" cy="60" r="51"/>
      <circle className="nexus-motion__ring nexus-motion__ring--inner" cx="90" cy="60" r="35"/>
      <path className="nexus-motion__trace" d="M90 0v24m0 72v24M30 60H5m170 0h-25"/>
      <path className="nexus-motion__signal" d="M53 60h17l8-18 13 36 10-24 7 6h19"/>
      <circle className="nexus-motion__core" cx="90" cy="60" r="5"/>
    </svg>}
  </span>;
}
